import { render } from "./DashboardValueRoadMapModal.vue?vue&type=template&id=356c3738"
import script from "./DashboardValueRoadMapModal.vue?vue&type=script&lang=js"
export * from "./DashboardValueRoadMapModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__